import { Col, DatePicker, Form, Input, Row } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import FulfilledPromiseConfirmationUtil from "./FulfilledPromiseConfirmationUtil";
import "./styles/RequestIPTVModal.css";
const { TextArea } = Input;

interface CreateOrUpdatePromiseOnInvoiceModalProps {
  show: boolean;
  handleClose: (isReload: boolean) => void;
  invoice: ConnectionInvoice;
}

const CreateOrUpdatePromiseOnInvoiceModal: React.FC<
  CreateOrUpdatePromiseOnInvoiceModalProps
> = ({ show, handleClose, invoice }) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postPromiseApi,
    promiseApiResponse,
    promiseApiError,
    promiseApiLoading,
    promiseApiMessage,
    promiseApiErrorCount,
  ] = useAxiosPost<CreateOrUpdatePromiseOnInvoiceApiProp>(
    "invoices/addOrUpdatePromiseOnInvoice",
    true
  );

  const [
    postFulfilPromiseApi,
    fulfilPromiseApiResponse,
    fulfilPromiseApiError,
    fulfilPromiseApiLoading,
    fulfilPromiseApiMessage,
    fulfilPromiseApiErrorCount,
  ] = useAxiosPost<FulfilPromiseOnInvoiceApiProp>(
    "invoices/updatePromiseToFulfill",
    true
  );
  const [isFulfilledClicked, setIsFulfilledClicked] = useState<boolean>(false);
  
  useEffect(() => {
    if (promiseApiError !== null && promiseApiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", promiseApiError);
    }
  }, [promiseApiError, promiseApiErrorCount]);
  
  useEffect(() => {
    if (promiseApiResponse !== null) {
      const { message } = promiseApiResponse;
      if (message) {
        openNotification(`success`, "Success", message);

        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [promiseApiResponse]);
  
  const dateFormat = "YYYY-MM-DD";
  const defaultDate =
    invoice.promiseDueDate !== null && invoice.promiseDueDate !== undefined
      ? invoice.promiseDueDate.slice(0, 10)
      : dayjs().format(dateFormat);
    
  const onFinish = (values: any) => {
    const { dueDate, promiseWords } = values;
    const promiseDateFormatted = dueDate.format("YYYY-MM-DD");
    const dataToSend: CreateOrUpdatePromiseOnInvoiceApiProp = {
      intPkConnectionInvoiceID: invoice.intPkConnectionInvoiceID,
      promiseDate: promiseDateFormatted,
      promiseWords,
    };
    postPromiseApi(dataToSend);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  
  const disabledDate = (currentDate: any) => {
    // Disable dates before today
    return currentDate && currentDate < dayjs().startOf("day");
  };
  
  const fulfilConfirmation = (confirm: boolean) => {
    if (confirm === false) {
      setIsFulfilledClicked(false);
      return;
    }
    postFulfilPromiseApi({
      intPkConnectionInvoiceID: invoice.intPkConnectionInvoiceID,
    });
  };
  
  useEffect(() => {
    if (fulfilPromiseApiError !== null && fulfilPromiseApiErrorCount !== 0) {
      openNotification(`error`, "Operation Failed", fulfilPromiseApiError);
    }
  }, [fulfilPromiseApiError, fulfilPromiseApiErrorCount]);
  
  useEffect(() => {
    if (fulfilPromiseApiResponse !== null) {
      const { message } = fulfilPromiseApiResponse;
      if (message) {
        openNotification(`success`, "Success", message);

        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [fulfilPromiseApiResponse]);
  
  return (
    <>
      <NetwalaModal
        title={
          invoice.promiseCreationDate !== null && invoice.promiseCreationDate !== undefined
            ? "Update Promise"
            : "Create Promise"
        }
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => handleClose(false)}
      >
        {contextHolder}
        {isFulfilledClicked === true ? (
          <FulfilledPromiseConfirmationUtil
            confirmationButton={fulfilConfirmation}
            message={` Did you received the final payment?`}
            isLoading={fulfilPromiseApiLoading}
          />
        ) : (
          <Row>
            <Col span={24} className="iptv-modal-package-details">
              <Form
                requiredMark={false}
                style={{ width: "100%" }}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                name="promiseForm"
                initialValues={{
                  dueDate: dayjs(defaultDate, dateFormat),
                  promiseWords: invoice.promiseWords || "",
                }}
              >
                <Form.Item
                  name="dueDate"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Promise Due Date",
                    },
                  ]}
                  label={
                    <span className="create-user-form-label">
                      Promise Due Date
                    </span>
                  }
                >
                  <DatePicker
                    style={{ width: "100%", height: "48px" }}
                    format={dateFormat}
                    defaultValue={dayjs(defaultDate, dateFormat)}
                    disabledDate={disabledDate}
                  />
                </Form.Item>

                <Form.Item
                  name="promiseWords"
                  rules={[
                    { required: true, message: "Please Add your comments" },
                  ]}
                  label={
                    <span className="create-user-form-label">Comments</span>
                  }
                >
                  <TextArea
                    className="user-input-general-height"
                    placeholder="user have the promise of 3 days"
                    rows={4}
                  />
                </Form.Item>
                <Form.Item>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      paddingBottom: "30px",
                      width: "100%",
                      paddingTop: "50px",
                    }}
                  >
                    <NetwalaButton
                      backgroundColor={ButtonProps.background.DANGER}
                      height={ButtonProps.height.STANDARD}
                      width={ButtonProps.width.ONE24}
                      textColor={ButtonProps.color.STANDARD}
                      onClick={() => {}}
                      htmlType="submit"
                      text={
                        invoice.promiseCreationDate !== null && invoice.promiseCreationDate !== undefined
                          ? "Update"
                          : "Create"
                      }
                      borderColor="#DF3131"
                      disabled={promiseApiLoading}
                    />
                    <NetwalaButton
                      disabled={promiseApiLoading}
                      backgroundColor={ButtonProps.background.SECONDARY}
                      height={ButtonProps.height.STANDARD}
                      width={ButtonProps.width.ONE24}
                      textColor={ButtonProps.color.BLACK}
                      onClick={() => handleClose(false)}
                      text="Cancel"
                      borderColor="#D7D7D7"
                    />
                  </div>
                </Form.Item>
                {invoice.promiseCreationDate !== null &&
                  invoice.promiseCreationDate !== undefined &&
                  Number(invoice.isPromiseFulfilled) !== 1 && (
                    <Form.Item>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          paddingBottom: "30px",
                          width: "100%",
                        }}
                      >
                        <NetwalaButton
                          backgroundColor={ButtonProps.background.STANDARD}
                          height={ButtonProps.height.STANDARD}
                          width={ButtonProps.width.STANDARD}
                          textColor={ButtonProps.color.STANDARD}
                          onClick={() => {
                            setIsFulfilledClicked(true);
                          }}
                          htmlType="button"
                          text="Fulfill Promise"
                          disabled={promiseApiLoading}
                        />
                      </div>
                    </Form.Item>
                  )}
              </Form>
            </Col>
          </Row>
        )}
      </NetwalaModal>
    </>
  );
};

export default CreateOrUpdatePromiseOnInvoiceModal;

